import {MarketState, SecurityMarketStateRecord} from "../models/SecurityMarketStateRecord";
import {MarketMapHierarchyData} from "../models/MarketMapHeirarchyData";
import {ArrayUtil} from "../../../../../../js/util/ArrayUtil";
import {
    IndustryGroup,
    industryGroupDescription
} from "../../../../../../instruments/industry-group/types/IndustryGroup";
import {ascending, sum} from "../../../../../../js/util/UtilFunctions";

export function buildChartData(state: MarketState, translateFilter: (value: string) => string): MarketMapHierarchyData {
    if (state.length === 0) {
        return {
            name: "ASX"
        };
    }
    const ignoredGroups = [IndustryGroup.NOT_APPLICABLE, IndustryGroup.CLASSIFICATION_PENDING];
    const filteredState = state.filter((s) => !ignoredGroups.includes(s.industryGroup));
    const grouped = ArrayUtil.mapBy(filteredState, (s) => s.industryGroup);
    const groupTotals = Array.from(grouped.values())
                             .map(groupTotal)
                             .sort(ascending);
    const cutoffIndex = Math.floor(groupTotals.length / 3);
    const cutoff = groupTotals[cutoffIndex];

    const topLevel = Array.from(grouped.entries())
                          .filter(([_, value]) => groupTotal(value) > cutoff)
                          .map(([key, value]) => buildChildren(translateFilter(`gics.${key}`), value));

    const other = Array.from(grouped.entries())
                       .filter(([_, value]) => groupTotal(value) <= cutoff)
                       .map(([key, value]) => buildChildren(translateFilter(`gics.${key}`), value));

    const otherChild = {
        name: "Other",
        children: other
    };

    const children = [...topLevel, otherChild];
    return {
        name: "ASX",
        children
    };
}

function groupTotal(records: ReadonlyArray<SecurityMarketStateRecord>): number {
    return records.map((r) => r.marketCap).reduce(sum, 0);
}

function buildChildren(industryGroup: string, records: ReadonlyArray<SecurityMarketStateRecord>): MarketMapHierarchyData {
    const children = records.map(buildChild);
    if (children.length === 0) {
        return {
            name: industryGroup
        };
    } else {
        return {
            name: industryGroup,
            children
        };
    }
}

function buildChild(record: SecurityMarketStateRecord): MarketMapHierarchyData {
    return {
        name: record.code,
        value: record.marketCap,
        state: record
    };
}
